import React from 'react';

import StatisticsQuestionView from './StatisticsQuestionView';
import MEMBERSTATES from '../../resources/political-constants';
import { RegionalGroupSelect } from '../Selects';

const ParentQuestions = ['text', 'stats_header'];

class HighlightedQuestion extends React.Component {
  constructor(props){
    super();

    this.state = {
      regionalGroup: 'GLOBAL',
    };
  }

  getResults(questions, region) {
    if (!Array.isArray(questions)) {
      questions = Object.values(questions);
    }

    return questions.map(item => {
      const regionResult = Object.assign({}, item[region]);
      regionResult.question = item.question;
      return regionResult;
    });
  }

  render() {
    const { question } = this.props;
    const { regionalGroup } = this.state;
    const type = question.input_type;

    const results = ParentQuestions.includes(type)
      ? this.getResults(question.questions, regionalGroup)
      : question[regionalGroup];

    return(
      <div className="card-showcase">
        <div className="main-question" >
          <p> { question.text || question.question } </p>
        </div>
          <RegionalGroupSelect
            className="react-input-field-small"
            value={regionalGroup}
            onChange = { (selectedValue) => { this.setState({ regionalGroup: selectedValue.value })} }
        />

        <div className="dataviz-area">
          { (typeof results === 'object') &&
              <StatisticsQuestionView
                type={ type }
                results={ results || [] }
                numberStates={ MEMBERSTATES[regionalGroup].number}
                participation={ question.participation ? question.participation[regionalGroup] : [] }
              />
          }
        </div>
      </div>
    );
  }
}

export default HighlightedQuestion;



// WEBPACK FOOTER //
// ./src/components/Statistics/HighlightedQuestion.js